module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-box text-center"
  }, [_c('p', {
    staticClass: "text-left little-title"
  }, [_vm._v(_vm._s(_vm.$t('MyInvitationCode')))]), _vm._v(" "), _c('div', {
    staticClass: "main-info"
  }, [_c('p', {
    staticClass: "invite-code"
  }, [_vm._v(_vm._s(_vm.$t('invitationCode'))), _c('span', [_vm._v(_vm._s(_vm.invitationCode))])]), _vm._v(" "), _c('div', {
    staticClass: "invite-url-box"
  }, [_c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.invitation_url))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.invitation_url),
      expression: "invitation_url",
      arg: "copy"
    }],
    staticClass: "copy",
    attrs: {
      "title": _vm.$t('clickCopy')
    },
    on: {
      "click": _vm.copyComplete
    }
  }, [_vm._v(_vm._s(_vm.$t('copy')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "copy"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.copied),
      expression: "copied"
    }],
    staticClass: "copy-complete"
  }, [_vm._v(_vm._s(_vm.$t('copySuccess')))])])], 1), _vm._v(" "), _c('p', {
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.$t('commissionExplanation')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16ecc982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commission/inviteFriend/InviteFriend.vue
// module id = 1268
// module chunks = 1